import React from "react";
import { useRouter } from "next/router";
import NotFoundPage from "pages/404";
import useJobDetailData from "hooks/api/job/useJobDetailData";
import { useFetchLocalStorage } from "lib/useFetchLocalStorage";
import useUser from "lib/useUser";
import { getLayout } from "components/layouts/job/Job";
import JobInformationRow from "components/job/index/jobInformationRow";
import DatelineAndTodoRow from "components/job/index/datelineAndTodoRow";
import IssueRow from "../../../components/job/index/issueRow";

const JobsDetailIndex = () => {
  useFetchLocalStorage();
  useUser({ redirectTo: "/login" });
  const router = useRouter();
  const { id } = router.query;
  const { data, status } = useJobDetailData(id);

  return (
    <>
      {status !== "loading" && status !== "idle" && !data ? (
        <NotFoundPage />
      ) : (
        <>
          <JobInformationRow data={data} status={status} />
          <DatelineAndTodoRow data={data} status={status} />
          <IssueRow data={data} status={status} />
        </>
      )}
    </>
  );
};

JobsDetailIndex.getLayout = getLayout;
export default JobsDetailIndex;
